import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { AbstractControl, NgForm } from "@angular/forms";
import { ScrBaseComponent } from "src/app/components/base.component";
import { ShortCodesService } from "src/app/services/shortcodes.service";


import { MbOptOutUpdateEvent } from "../common-events";

@Component({
  selector: 'app-common-mb-opt-out',
  templateUrl: './mb-opt-out.component.html'
})
export class MbOptOutComponent extends ScrBaseComponent implements OnInit {

  public trackingNumberValue = "";
  public cancelSc = false;
  public heading = "Opt Out of Monthly Billing";

  isDisabled = false;

  @Input() scId!: number;
  @Input() message!: string;
  @Input() leaseId!: number;

  @Output() update = new EventEmitter<MbOptOutUpdateEvent>();

  constructor(private scService: ShortCodesService) {
    super();
  }

  ngOnInit() {
    this.isDisabled = false;
  }

  onSubmit(cancelForm: NgForm): void {
    this.isDisabled = false;
    if (cancelForm.valid) {
      this.observe(this.scService.mbOptOut(this.leaseId, this.cancelSc), {
        onSuccess: res => {
          this.isDisabled = true;
          this.update.emit({ isCompleted: true, response: res });
          return false;
        },
        onError: () => {
          this.isDisabled = false;
          return true;
        }
      });
    }
    else {
      this.isDisabled = false;
      Object.values(cancelForm.controls).forEach((control: AbstractControl) => {
        control.markAsTouched();
      });
      this.scrollToFirstError();
    }
  }

  onCancel(): void {
    this.cancelSc = false;
    this.update.emit({ isCompleted: false });
  }

}
